

import axios from 'axios';
import store from '@/store'; // Adjust the path as necessary to point to your store

// Function to check token expiration
const isTokenExpiring = (token) => {
    if (!token) {
        console.log("No token provided. Treated as expired.");
        return true; // No token means expired
    }

    const decoded = JSON.parse(atob(token.split('.')[1])); // Decode JWT token
    const expTime = decoded.exp * 1000; // Convert exp time to milliseconds
    const currentTime = Date.now();
//  window.location.href = '/logout'
    // Check if the token is expired
    if (expTime <= currentTime) {
        const timeLeft = (currentTime - expTime) / 1000; // Calculate time left in seconds
        console.log(`Token expired. Time since expiration: ${timeLeft.toFixed(2)} seconds.`);
        // window.location.href = '/logout'; // Change this to your login URL
        localStorage.removeItem('token')
        window.location.reload();
        //  window.location.href = '/logout'
        return false; // Return false if expired
    }

    // Check if there are less than 10 minutes (600,000 ms) left and at least 1 second (1,000 ms) until that point
    const timeUntilExpiration = expTime - currentTime;
    const refreshMinute = +process.env.REFRESH_TIME
    // console.log("TOKEN MINUTE REFRESH : ")
    // console.log(refreshMinute)
    if (timeUntilExpiration < refreshMinute * 60 * 1000 && timeUntilExpiration > 1000) {
        console.log(`Token expiring soon. Time left: ${(timeUntilExpiration / 1000).toFixed(2)} seconds.`);
        return true; // Return true if less than 10 minutes left
    }
    else{
        console.log(`Token will expired on  ${(timeUntilExpiration / 1000).toFixed(2) } seconds`)
    }

    return false; // Return false if more than 10 minutes left
};


// Function to refresh token
const refreshAccessToken = async (refreshToken) => {
    try {
        // const response = await axios.get(`${process.env.VUE_APP_API}/auth/refresh`); // Adjust the URL as needed
        const response = await fetch(`${process.env.VUE_APP_API}/auth/refresh`, {
            method: 'POST', // or 'POST' depending on your API
            headers: {
                'Content-Type': 'application/json',
                // Include any necessary headers, like a refresh token if needed
            },
            body: JSON.stringify({refresh_token:refreshToken})
        });
    
        if (!response.ok) {
            throw new Error('Failed to refresh token');
        }
    
        const data = await response.json();
        return data.access_token;
        // return response.data.token; // Assuming the new token is returned here
    } catch (error) {
        console.error('Error refreshing token:', error);
        throw error; // Handle the error accordingly
    }
};

// Add request interceptor
axios.interceptors.request.use(
    async (config) => {
        const accessToken = localStorage.getItem('token'); // Or however you store your tokens
        if(accessToken){
            console.log("mempunyai token")
        if (isTokenExpiring(accessToken)) {

        const refreshToken = localStorage.getItem('refresh_token'); 
            try {


                const newToken = await refreshAccessToken(refreshToken);
                
                localStorage.setItem('token', newToken); // Store new 
                
                store.dispatch("setTokenByRefresh", { newToken })
                config.headers['Authorization'] = `Bearer ${newToken}`; // Set new token in headers
            } catch (error) {
                // Handle error (e.g., redirect to login if unable to refresh token)
                console.error('Failed to refresh token:', error);
            }
        } else {
            config.headers['Authorization'] = `Bearer ${accessToken}`; // Set existing token
        }
    }else{
        console.log("tidak mempunyai token")
    }
        return config;
        
    },
    (error) => {
        return Promise.reject(error);
    }
);
